// assets/images.ts
import BG from './BG.webp';
import bitgetWallet_Icon from './bitgetWallet_Icon.webp';
import empty from './empty.webp';
import result_failed from './result_failed.webp';
import result_success from './result_success.webp';
import iconCheck from './icon-check.webp';
import iconClose from './icon-close.webp';
import iconLoading from './icon-loading.webp';

import BWB from '@assets/images/token/BWB.svg';
import BGB from '@assets/images/token/BGB.svg';
import Solana from '@assets/images/Mainnet/Solana.svg';
import Base from '@assets/images/Mainnet/Base.svg';
import ETH from '@assets/images/Mainnet/ETH.svg';
import Ton from '@assets/images/Mainnet/Ton.svg';
import Morph from '@assets/images/Mainnet/Morph.svg';

// 通用图片
export const CommonImages = {
  BG,
  bitgetWallet_Icon,
  empty,
  result_failed,
  result_success,
  iconCheck,
  iconClose,
  iconLoading,
};

// 代币图标
export const TokenIcons = {
  BWB,
  BGB,
};

// 链图标
export const ChainIcons = {
  Solana,
  Base,
  ETH,
  Ton,
  Morph,
};
